export const stripSpecialChars = v => {
  const stripped = v.replace(
    /[\s"'.,-\/#!$%\^&*;:{}=\-_`~()\\\[\]@+|?><]/g,
    ""
  );
  return stripped;
};
